import {
  CommonCompenentDataMarket,
  CompenentDataMarketFirstSecondExtraTime,
  CompenentDataMarketDefault,
  CompenentDataMarketDynamic,
} from "./GlobalComponents";
import { createListBetHomeDemarkOnFilter } from "./GlobalFunctions";

export const orderLoop = [
  "first_home_bet",
  "second_home_bet",
  "third_home_bet",
  "fourth_home_bet",
];
export const linkChangePlan = "/renovacao";
export const linkWhatsapp = "/content/links/suporte";
export const linkInstagram = "/content/links/instagram";
export const linkYoutube = "/content/links/youtube";
export const linkTestGratis = "/content/links/teste-gratis";
export const listSortType = ["Lucro", "Início", "Recentes"];
export const listSortTypeToSelect = { início: "Início", recentes: "Recentes" };

export const NameBetHomeRenamed = {
  "betano(br)": "Betano",
  "vbet(lat)": "Vbet",
  "bodog(en)": "Bodog",
};

export const managerClonerBetHome = {
  allBetHomeAbleToClone: [
    "bet-bra",
    "bet7k",
    "betesporte",
    "betfast",
    "betnacional",
    "betão",
    "blaze",
    "esportesdasorte",
    "estrelabet",
    "hiperbet",
    "marjosports",
    "sportingbet",
    "stake",
    "vbet",
    "vivasorte",
    "betrebels",
    "mystake",
    "fortunejack",
  ],

  fortunejack: {
    allBetHomeClone: [
      "bet25",
      "betfury",
      "betpanda",
      "betwhale",
      "crashino",
      "csgoempire",
      "duckdice",
      "duel",
      "hiperwin",
      "jackpotter",
      "lucky block",
      "rainbet",
      "rollbit",
      "roobet",
      "superboss",
      "tg·casino",
      "thrill",
      "true luck",
      "trustdice",
      "winna",
      "wsmcasino",
    ],
    betfury: {
      nameBetHome: "BetFury",
      baseURL:
        "https://bf1.io/pt-br/sports/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    betpanda: {
      nameBetHome: "Betpanda",
      baseURL:
        "https://betpanda1.io/pt/sportsbook/?bt-path=%2Fsoccer%2Fengland%2Fpremier-league%2Farsenal-fc-leeds-united-2710598317431197731",
    },
    betwhale: {
      nameBetHome: "Betwhale",
      baseURL:
        "https://betwhale.ag/sportsbook/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    csgoempire: {
      nameBetHome: "CsgoEmpire",
      baseURL:
        "https://csgoempire.com/match-betting?bt-path=%2Fsoccer%2Fengland%2Fpremier-league%2Farsenal-fc-leeds-united-2710598317431197731",
    },
    duckdice: {
      nameBetHome: "DuckDice",
      baseURL:
        "https://duckdice.io/sport/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    duel: {
      nameBetHome: "Duel",
      baseURL:
        "https://duel.com/sports?bt-path=/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    jackpotter: {
      nameBetHome: "Jackpotter",
      baseURL:
        "https://jackpotter.com/br/sports?bt-path=%2Fsoccer%2Fengland%2Fpremier-league%2Farsenal-fc-leeds-united-2710598317431197731",
    },
    hiperwin: {
      nameBetHome: "HiperWin",
      baseURL:
        "https://www.hiperwin.com/pb/game/sports/?bt-path=/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    "lucky block": {
      nameBetHome: "Lucky Block",
      baseURL:
        "https://www.luckyblock.top/pt/apostas-esportivas/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    rainbet: {
      nameBetHome: "Rainbet",
      baseURL:
        "https://rainbet.com/sportsbook/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    rollbit: {
      nameBetHome: "Rollbit",
      baseURL:
        "https://rollbit.com/sports?bt-path=%2Fsoccer%2Fengland%2Fpremier-league%2Farsenal-fc-leeds-united-2710598317431197731",
    },
    roobet: {
      nameBetHome: "Roobet",
      baseURL:
        "https://roobet.com/sports/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    superboss: {
      nameBetHome: "Superboss",
      baseURL:
        "https://superboss.com/pt-br/sportsbook?bt-path=%2Fsoccer%2Fengland%2Fpremier-league%2Farsenal-fc-leeds-united-2710598317431197731",
    },
    "tg·casino": {
      nameBetHome: "TG·Casino",
      baseURL:
        "https://www.tg.casino/sports?bt-path=%2Fsoccer%2Fengland%2Fpremier-league%2Farsenal-fc-leeds-united-2710598317431197731",
    },
    thrill: {
      nameBetHome: "Thrill",
      baseURL:
        "https://thrill.com/sports/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    "true luck": {
      nameBetHome: "True Luck",
      baseURL:
        "https://trueluck.com/sports/?bt-path=%2Fsoccer%2Fengland%2Fpremier-league%2Farsenal-fc-leeds-united-2710598317431197731",
    },
    trustdice: {
      nameBetHome: "Trustdice",
      baseURL:
        "https://trustdice.win/pt/sports/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    winna: {
      nameBetHome: "Winna",
      baseURL:
        "https://winna.com/pt-BR/sportsbook/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
    wsmcasino: {
      nameBetHome: "WSMCasino",
      baseURL:
        "https://www.wsmcasino.com/pt/sports?bt-path=%2Fsoccer%2Fengland%2Fpremier-league%2Farsenal-fc-leeds-united-2710598317431197731",
    },
    crashino: {
      nameBetHome: "Crashino",
      baseURL:
        "https://www.crashino.com/pt/sports?bt-path=%2Fsoccer%2Fengland%2Fpremier-league%2Farsenal-fc-leeds-united-2710598317431197731",
    },
    bet25: {
      nameBetHome: "Bet25",
      baseURL:
        "https://bet25.com/pt-br/sports/soccer/england/premier-league/arsenal-fc-leeds-united-2710598317431197731",
    },
  },

  mystake: {
    allBetHomeClone: [
      "donbet",
      "freshbet",
      "goldenbet",
      "jack",
      "rolletto",
      "spassino",
      "velobet",
    ],
    donbet: {
      nameBetHome: "DonBet",
      baseURL: "https://donbet.com/en/sportsbook/prematch/match/76146368",
    },
    freshbet: {
      nameBetHome: "freshbet",
      baseURL: "https://freshbet.com/sportsbook/prematch/match/76146368",
    },
    goldenbet: {
      nameBetHome: "Goldenbet",
      baseURL:
        "https://goldenbet.com/eng/sportsbook/prematch#/prematch?match=76146368",
    },
    jack: {
      nameBetHome: "Jack",
      baseURL: "https://jack.com/br/sportsbook/prematch/match/76146368",
    },
    velobet: {
      nameBetHome: "VeloBet",
      baseURL:
        "https://velobet.com/br/sportsbook/prematch#/prematch/match/76146368",
    },
    rolletto: {
      nameBetHome: "Rolletto",
      baseURL:
        "https://rolletto.win/br/sportsbook/prematch#/prematch/match/76146368",
    },
    spassino: {
      nameBetHome: "Spassino",
      baseURL:
        "https://spassino.com/en/sportsbook/prematch#/prematch?match=76146368",
    },
  },

  betrebels: {
    allBetHomeClone: [
      "21bets",
      "allbritishcasino",
      "betista",
      "betovo",
      "casinado",
      "cazimbo",
      "crownplay",
      "fezbet",
      "goldspin",
      "malina",
      "mundoapostas",
      "novajackpot",
      "rabona",
      "slotsnbets",
      "theredlion",
      "vavada",
    ],
    fezbet: {
      nameBetHome: "FEZbet",
      baseURL:
        "https://fezbet-9784.com/br/sport?sportids=66&catids=0&champids=2936&eventid=17487543",
    },
    allbritishcasino: {
      nameBetHome: "AllBritishCasino",
      baseURL:
        "https://www.allbritishcasino.com/en/sports-book/sports?page=event&eventId=17487543&sportId=66",
    },
    betista: {
      nameBetHome: "Betista",
      baseURL:
        "https://www.betista167711.com/br/sports?page=event&sportId=66&eventId=17487543&championshipIds=[2936]&categoryIds=[497]&sportName=Futebol",
    },
    betovo: {
      nameBetHome: "Betovo",
      baseURL:
        "https://www.betovo3184705.com/br/sports?page=event&sportId=66&eventId=17487543&championshipIds=[2936]&categoryIds=[497]&sportName=Futebol",
    },
    casinado: {
      nameBetHome: "Casinado",
      baseURL:
        "https://casinado1.com/br/sports?page=event&eventId=17487543&sportId=66",
    },
    cazimbo: {
      nameBetHome: "Cazimbo",
      baseURL:
        "https://cazimbo-2518.com/br/sport?sportRoutingParams=page~event__sportId~66__categoryIds~497__championshipIds~2936__eventId~17487543&page=event&eventid=17962195&sportids=68",
    },
    crownplay: {
      nameBetHome: "Crownplay",
      baseURL:
        "https://crownplay4.com/br/sport?sportRoutingParams=page~event__sportId~66__categoryIds~497__championshipIds~2936__eventId~17487543&page=event&eventid=17962195&sportids=68",
    },
    goldspin: {
      nameBetHome: "GoldSpin",
      baseURL:
        "https://www.goldspin6248139.com/br/sports?page=event&sportId=66&eventId=17487543&championshipIds=[2936]&categoryIds=[497]&sportName=Futebol",
    },
    malina: {
      nameBetHome: "Malina",
      baseURL:
        "https://malinacasino-2836.com/en/sport?sportRoutingParams=page~prelive__eventid~17487543__sportids~66__catids~0__champids~2936&page=event&eventid=17962195&sportids=68",
    },
    novajackpot: {
      nameBetHome: "NovaJackpot",
      baseURL:
        "https://novajackpot-1589.com/br/sport?sportRoutingParams=page~event__sportId~66__categoryIds~497__championshipIds~2936__eventId~17487543&page=event&eventid=17962195&sportids=68",
    },
    theredlion: {
      nameBetHome: "TheRedLion",
      baseURL:
        "https://theredlioncasino.co/sports?page=event&eventId=17487543&sportId=66",
    },
    slotsnbets: {
      nameBetHome: "SlotsNBets",
      baseURL:
        "https://snbets.co/sports?page=event&eventId=17487543&sportId=66",
    },
    vavada: {
      nameBetHome: "Vavada",
      baseURL:
        "https://vavada.com/en/sports#/sport/66/category/497/championship/2936/event/17487543",
    },
    mundoapostas: {
      nameBetHome: "MundoApostas",
      baseURL:
        "https://www.mundoapostas42.com/sportsbook#/sport/66/category/497/championship/2936/event/17487543",
    },
    rabona: {
      nameBetHome: "Rabona",
      baseURL:
        "https://rab0na-2417.com/br/sport?sportRoutingParams=page~event__sportId~66__categoryIds~497__championshipIds~2936__eventId~17487543&page=event&eventid=17962195&sportids=68",
    },
    "21bets": {
      nameBetHome: "21Bets",
      baseURL:
        "https://21bets7.com/pt/sports?page=event&eventId=17487543&sportId=66",
    },
  },
  esportesdasorte: {
    allBetHomeClone: ["lottu"],
    lottu: {
      baseURL: "https://www.lottu.bet.br/sports",
      nameBetHome: "Lottu",
    },
  },
  marjosports: {
    allBetHomeClone: ["bingoplus"],
    bingoplus: {
      baseURL: "https://www.bingoplus.bet.br/sports",
      nameBetHome: "BingoPlus",
    },
  },
  betão: {
    allBetHomeClone: ["7games", "r7bet"],
    "7games": {
      baseURL: "https://7games.bet.br",
      nameBetHome: "7Games",
    },
    r7bet: {
      baseURL: "https://r7.bet.br",
      nameBetHome: "R7Bet",
    },
  },
  hiperbet: {
    allBetHomeClone: ["oleybet"],
    oleybet: {
      baseURL: "https://oleybet.bet.br/",
      nameBetHome: "Oleybet",
    },
  },
  vivasorte: {
    allBetHomeClone: ["4win", "bandbet", "energia.bet", "zeroum"],
    zeroum: {
      baseURL: "https://zeroum.bet",
      nameBetHome: "Zeroum",
    },
    bandbet: {
      baseURL: "https://www.bandbet.bet.br",
      nameBetHome: "BandBet",
    },
    "4win": {
      baseURL: "https://4win.bet.br",
      nameBetHome: "4WIN",
    },
    "energia.bet": {
      baseURL: "https://energia.bet.br",
      nameBetHome: "energia.bet",
    },
  },
  sportingbet: {
    allBetHomeClone: ["betboo"],
    betboo: {
      baseURL: "https://sports.br.betboo.com",
      nameBetHome: "Betboo",
    },
  },
  betnacional: {
    allBetHomeClone: ["apostabet", "bet4", "fazobet"],

    bet4: {
      baseURL: "https://bet4.bet.br/esportes/x/evento/sr:match:",
      nameBetHome: "Bet4",
    },
    apostabet: {
      baseURL: "https://aposta.bet.br/esportes/x/evento/sr:match:",
      nameBetHome: "ApostaBet",
    },
    fazobet: {
      baseURL: "https://fazo.bet.br/esportes/x/evento/sr:match:",
      nameBetHome: "FazObet",
    },
  },
  estrelabet: {
    allBetHomeClone: [
      "4play",
      "aposta1",
      "apostou",
      "aviaobet",
      "bateubet",
      "betfusion",
      "betpix365",
      "br4",
      "brasildasorte",
      "brbet",
      "cbesportes",
      "donosdabola",
      "esportivabet",
      "esportivavip",
      "f12bet",
      "ginga.bet",
      "goldebet",
      "jogodeouro",
      "lotogreen",
      "lottoland",
      "luvabet",
      "mcgames",
      "multibet",
      "nossabet",
      "onabet",
      "pagol",
      "playbet",
      "sorteonline",
      "startbet",
      "upbet",
      "vaidebet",
      "vupi",
    ],
    startbet: {
      baseURL: "https://start.bet.br/sports/xxxx/xxxxxx/xxxxxxx-vs-xxxxx/e-",
      nameBetHome: "StartBet",
    },
    luvabet: {
      baseURL:
        "https://luva.bet.br/sportsbook?page=event&sportId=66&categoryIds=593&championshipIds=11005&eventId=",
      nameBetHome: "Luvabet",
    },
    esportivavip: {
      baseURL:
        "https://esportivavip.bet.br/sports/xxxx/xxxxxx/xxxxxxx-vs-xxxxx/ev-",
      nameBetHome: "EsportivaVIP",
    },
    donosdabola: {
      baseURL:
        "https://donosdabola.bet.br/sports/xxxx/xxxxxx/xxxxxxx-vs-xxxxx/ev-",
      nameBetHome: "DonosdaBola",
    },
    cbesportes: {
      baseURL:
        "https://cbesportes.bet.br/sports/xxxx/xxxxxx/xxxxxxx-vs-xxxxx/ev-",
      nameBetHome: "CBEsportes",
    },
    playbet: {
      baseURL: "https://play.bet.br/sports/xxxx/xxxxxx/xxxxxxx-vs-xxxxx/ev-",
      nameBetHome: "Playbet",
    },
    "ginga.bet": {
      baseURL:
        "https://ginga.bet.br/apostas-esportivas?page=event&sportId=66&eventId=",
      nameBetHome: "Ginga.bet",
    },
    "4play": {
      baseURL:
        "https://4play.bet.br/apostas-esportivas?page=event&sportId=66&eventId=",
      nameBetHome: "4Play",
    },
    betpix365: {
      baseURL:
        "https://www.betpix365.bet.br/sports#/sport/66/category/593/championship/11005/event/",
      nameBetHome: "BetPix365",
    },
    vaidebet: {
      baseURL:
        "https://www.vaidebet.bet.br/sports#/sport/66/category/593/championship/11318/event/",
      nameBetHome: "Vaidebet",
    },
    aviaobet: {
      baseURL:
        "https://www.aviao.bet.br/esportes#/sport/66/category/593/championship/11318/event/",
      nameBetHome: "AviaoBet",
    },
    apostou: {
      baseURL:
        "https://www.apostou.bet.br/sports#/sport/66/category/593/championship/11318/event/",
      nameBetHome: "Apostou",
    },
    f12bet: {
      baseURL: "https://f12.bet.br/sports/xxxx/xxxxxx/xxxxxxx-vs-xxxxx/e-",
      nameBetHome: "F12Bet",
    },
    onabet: {
      baseURL:
        "https://ona.bet.br/sportsbook?page=event&sportId=66&categoryIds=593&championshipIds=11005&eventId=",
      nameBetHome: "OnaBet",
    },
    brbet: {
      baseURL:
        "https://www.brbet.bet.br/sports#/sport/66/category/497/championship/2937/liveEvent/",
      nameBetHome: "BrBet",
    },
    brasildasorte: {
      baseURL:
        "https://www.brasildasorte.bet.br/sports/xxxx/xxxxxx/xxxxxxx-vs-xxxxx/e-",
      nameBetHome: "Brasildasorte",
    },
    betfusion: {
      baseURL:
        "https://betfusion.bet.br/sports/xxxx/xxxxxx/xxxxxxx-vs-xxxxx/e-",
      nameBetHome: "Betfusion",
    },
    vupi: {
      baseURL: "https://www.vupi.bet.br",
      nameBetHome: "Vupi",
    },
    upbet: {
      baseURL:
        "https://up.bet.br/en/sports/live#/sport/66/category/593/championship/2942/event/",
      nameBetHome: "UPBET",
    },
    nossabet: {
      baseURL: "https://nossa.bet.br/br",
      nameBetHome: "nossabet",
    },
    jogodeouro: {
      baseURL: "https://jogodeouro.bet.br/pt/sports?page=event&eventId=",
      nameBetHome: "Jogodeouro",
    },
    sorteonline: {
      baseURL: "https://www.sorteonline.bet.br/aposta-esportiva",
      nameBetHome: "SorteOnline",
    },
    lottoland: {
      baseURL: "https://www.lottoland.bet.br/aposta-esportiva",
      nameBetHome: "Lottoland",
    },
    br4: {
      baseURL:
        "https://br4.bet.br/sports/xxxxxx/xxxxxx/xxxxx-xx-xx-xxxxxxxx/e-",
      nameBetHome: "BR4",
    },
    goldebet: {
      baseURL:
        "https://goldebet.bet.br/sports/xxxxxx/xxxxxx/xxxxx-xx-xx-xxxxxxxx/e-",
      nameBetHome: "Goldebet",
    },
    lotogreen: {
      baseURL:
        "https://lotogreen.bet.br/sports/xxxxxx/xxxxxx/xxxxx-xx-xx-xxxxxxxx/e-",
      nameBetHome: "Lotogreen",
    },
    esportivabet: {
      baseURL:
        "https://esportiva.bet.br/sports/xxxxxx/xxxxxx/xxxxx-xx-xx-xxxxxxxx/e-",
      nameBetHome: "Esportivabet",
    },
    aposta1: {
      baseURL:
        "https://www.aposta1.bet.br/esportes#/sport/66/category/593/championship/11318/event/",
      nameBetHome: "Aposta1",
    },
    mcgames: {
      baseURL:
        "https://mcgames.bet.br/sports/xxxxxx/xxxxxx/xxxxx-xx-xx-xxxxxxxx/e-",
      nameBetHome: "McGames",
    },
    bateubet: {
      baseURL:
        "https://bateu.bet.br/sports/xxxxxx/xxxxxx/xxxxx-xx-xx-xxxxxxxx/e-",
      nameBetHome: "BateuBet",
    },
    multibet: {
      baseURL:
        "https://multi.bet.br/sports#/sport/66/category/593/championship/11318/event/",
      nameBetHome: "Multibet",
    },
    pagol: {
      baseURL: "https://pagol.bet.br/br/aposta-esportiva",
      nameBetHome: "Pagol",
    },
  },
  "bet-bra": {
    allBetHomeClone: ["bolsadeaposta", "matchbook"],
    bolsadeaposta: {
      baseURL: "https://bolsadeaposta.bet.br",
      nameBetHome: "BolsaDeAposta",
    },
    matchbook: {
      baseURL: "https://matchbook.bet.br",
      nameBetHome: "Matchbook",
    },
  },
  vbet: {
    allBetHomeClone: [
      "1pra1",
      "h2bet",
      "luckbet",
      "maximabet",
      "segurobet",
      "seubet",
      "supremabet",
      "ultrabet",
    ],
    "1pra1": {
      baseURL: "https://www.1pra1.bet.br/esportes/match/todayEvents",
      nameBetHome: "1pra1",
    },
    luckbet: {
      baseURL: "https://www.luck.bet.br/esportes/match/todayEvents",
      nameBetHome: "LuckBet",
    },
    segurobet: {
      baseURL: "https://www.seguro.bet.br/esportes/match",
      e_sportBaseURL:
        "https://www.seguro.bet.br/e-sports/match/xxe-sportxx/all/all/xxidzz",
      nameBetHome: "Segurobet",
    },
    seubet: {
      baseURL: "https://www.seu.bet.br/pre-jogo/match/topLeague",
      nameBetHome: "Seubet",
    },
    h2bet: {
      baseURL: "https://www.h2.bet.br/esportes/match",
      nameBetHome: "H2Bet",
    },
    supremabet: {
      baseURL:
        "https://suprema.bet.br/pb/sports/pre-match/event-view/Soccer/Brazil/1792/xxxxxxxxxxx-xxxxx-x/27656663/xxx-xxxxxx-xxxxxxx",
      e_sportBaseURL:
        "https://suprema.bet.br/pb/esports/upcoming/xxe-sportxx/xxidzz?selectedTab=2  ",
      nameBetHome: "SupremaBet",
    },
    maximabet: {
      baseURL: "https://www.maxima.bet.br/esportes/match",
      nameBetHome: "MaximaBet",
    },
    ultrabet: {
      baseURL: "https://ultra.bet.br/e/sport",
      nameBetHome: "UltraBet",
    },
  },
  betfast: {
    allBetHomeClone: [
      "6r",
      "9fbet",
      "betapp",
      "brazino777",
      "faz1bet",
      "fogo777",
      "ijogo",
      "p9",
      "tivobet",
      "wjcassino",
    ],
    brazino777: {
      baseURL: "https://www.brazino777.bet.br/game/prematch-mts/",
      nameBetHome: "Brazino777",
    },
    faz1bet: { baseURL: "https://faz1.bet.br/", nameBetHome: "Faz1bet" },
    tivobet: {
      baseURL: "https://tivo.bet/br/sportsbook/prematch#/",
      nameBetHome: "Tivobet",
    },
    "9fbet": {
      baseURL: "https://sportlt.upgaming.com/?c=9F&brand=293&lang=br#/",
      nameBetHome: "9fBet",
      linkBetHome: "https://9f.bet.br/br/web/sports",
    },
    ijogo: {
      baseURL: "https://sportlt.upgaming.com/?c=ijogo&brand=289&lang=br#/",
      nameBetHome: "Ijogo",
      linkBetHome: "https://ijogo.bet.br/br/web",
    },
    wjcassino: {
      baseURL: "https://sportlt.upgaming.com/?c=wjcasino&brand=262&lang=br#/",
      nameBetHome: "WjCassino",
      linkBetHome: "https://wjcasino.bet.br/br/web",
    },
    fogo777: {
      baseURL: "https://sportlt.upgaming.com/?c=fogo777&brand=267&lang=br#/",
      nameBetHome: "Fogo777",
      linkBetHome: "https://fogo777.bet.br/sports",
    },
    "6r": {
      baseURL: "https://sportlt.upgaming.com/?c=6r&brand=276&lang=br#/",
      nameBetHome: "6R",
      linkBetHome: "https://6r.bet.br",
    },
    betapp: {
      baseURL: "https://sportlt.upgaming.com/?c=betapp&brand=261&lang=br#/",
      nameBetHome: "BetApp",
      linkBetHome: "https://betapp.bet.br",
    },
    p9: {
      baseURL: "https://sportlt.upgaming.com/?c=p9&brand=273&lang=br#/",
      nameBetHome: "P9",
      linkBetHome: "https://p9.bet.br",
    },
  },
  bet7k: {
    allBetHomeClone: [
      "apostamax",
      "apostatudo",
      "b1bet",
      "bet-bra sb",
      "bet.bet",
      "betdásorte",
      "betfalcons",
      "betgorillas",
      "betou",
      "betvip",
      "bigbet",
      "brabet",
      "bravobet",
      "brx",
      "bullsbet",
      "cassino",
      "donald",
      "ganheibet",
      "geralbet",
      "ice.bet",
      "jogao",
      "kingpanda",
      "lider",
      "mmabet",
      "pixbet",
      "rico",
      "sortenabet",
      "tradicional",
      "vera",
    ],
    bravobet: {
      baseURL:
        "https://prod20434-188618173.fssb.io/br-pt/spbkv3/xxxxxxx/xxxxxx/xxxxxxxxxxx-xxxxx-x/xxxxxxxx-xx-xxxxxxxx-xx",
      nameBetHome: "BravoBet",
      linkBetHome: "https://bravo.bet.br/esportiva",
    },
    brabet: {
      baseURL: "https://bra.bet.br",
      nameBetHome: "BraBet",
    },
    tradicional: {
      baseURL: "https://prod20434-185603016.fssb.io/br-pt/spbk",
      nameBetHome: "Tradicional",
      linkBetHome: "https://tradicional.bet.br/esportiva",
    },
    bigbet: {
      baseURL: "https://prod20480.fssb.io/br-pt/spbk",
      nameBetHome: "Bigbet",
      linkBetHome: "https://big.bet.br/sportsbook",
    },
    ganheibet: {
      baseURL: "https://ganhei.bet.br",
      nameBetHome: "Ganheibet",
    },
    cassino: {
      baseURL: "https://cassino.bet.br",
      nameBetHome: "Cassino",
    },

    betvip: {
      baseURL: "https://betvip.bet.br/sports//",
      nameBetHome: "Betvip",
    },
    "bet-bra sb": {
      baseURL:
        "https://betbra.bet.br/fbook/br-pt/spbk/xxxxxxx/xxxxxx/xxxxxxxxxxx-xxxxx-x/xxxxxxxx-xx-xxxxxxxx-xx",
      nameBetHome: "Bet-Bra SB",
    },
    geralbet: { baseURL: "https://geralbet.bet.br", nameBetHome: "Geralbet" },
    lider: {
      baseURL:
        "https://prod20350-169228031.fssb.io/br-pt/spbk/xxxxx/xxxxx/xxxxx/xxxxx",
      nameBetHome: "Lider",
      linkBetHome: "https://lider.bet.br",
    },
    kingpanda: {
      baseURL:
        "https://prod20441-172895345.fssb.io/br-pt/spbk/xxxxxxx/xxxxxx/xxxxxxxxxxx-xxxxxx-x/xxxxxxxxxx-xx-xx-xxxxxxxxxxxx",
      nameBetHome: "KingPanda",
      linkBetHome: "https://kingpanda.bet.br/bets",
    },
    apostatudo: {
      baseURL: "https://apostatudo.bet.br",
      nameBetHome: "Apostatudo",
    },
    betgorillas: {
      baseURL: "https://betgorillas.bet.br",
      nameBetHome: "Betgorillas",
    },
    sortenabet: {
      baseURL: "https://sortenabet.bet.br",
      nameBetHome: "Sortenabet",
    },
    vera: { baseURL: "https://vera.bet.br", nameBetHome: "Vera" },
    apostamax: {
      baseURL: "https://apostamax.bet.br",
      nameBetHome: "Apostamax",
    },
    brx: { baseURL: "https://brx.bet.br", nameBetHome: "Brx" },
    bullsbet: { baseURL: "https://bullsbet.bet.br", nameBetHome: "Bullsbet" },
    donald: { baseURL: "https://donald.bet.br", nameBetHome: "Donald" },
    pixbet: {
      baseURL: "https://prod20383.fssb.io",
      nameBetHome: "Pixbet",
      linkBetHome: "https://pix.bet.br/sports/",
    },
    "bet.bet": {
      baseURL: "https://betpontobet.bet.br",
      nameBetHome: "Bet.Bet",
    },
    betdásorte: {
      baseURL:
        "https://betdasorte.bet.br/sports/xxxxxxx/xxxxxx/xxxxxxxxxx-xxxxx-x/xxxxxx-xxxxxxx",
      nameBetHome: "BetDáSorte",
    },
    betou: { baseURL: "https://betou.bet.br", nameBetHome: "Betou" },
    rico: { baseURL: "https://rico.bet.br", nameBetHome: "Rico" },
    jogao: { baseURL: "https://jogao.bet.br", nameBetHome: "Jogao" },
    b1bet: { baseURL: "https://www.b1bet.bet.br", nameBetHome: "B1Bet" },
    betfalcons: {
      baseURL: "https://betfalcons.bet.br",
      nameBetHome: "BetFalcons",
    },
    mmabet: {
      baseURL:
        "https://mmabet.bet.br/sports/Futebol/xxxxxx/xxxxxx/xxxxxxxxxx-xxxxx-x",
      nameBetHome: "MmaBet",
      linkBetHome: "https://mmabet.bet.br",
    },
    "ice.bet": {
      baseURL:
        "https://prod20419-165333121.fssb.io/br-pt/spbk/xxxxx/xxxxx/xxxxx/xxxxx",
      nameBetHome: "ice.bet",
      linkBetHome: "https://ice.bet.br/sports/live",
    },
  },
  stake: {
    allBetHomeClone: ["betwarrior", "kto", "reidopitaco"],
    kto: {
      baseURL: "https://www.kto.bet.br",
      nameBetHome: "KTO",
    },
    betwarrior: {
      baseURL: "https://apostas.betwarrior.bet.br/pt-br/sports/event",
      nameBetHome: "Betwarrior",
    },
    reidopitaco: {
      baseURL: "https://reidopitaco.bet.br/betting",
      nameBetHome: "ReidoPitaco",
    },
  },
  blaze: {
    allBetHomeClone: [
      "afun",
      "apostaonline",
      "betboom",
      "bingobet",
      "jonbet",
      "onlybets",
      "pinbet",
      "reals",
      "xxbet",
      "zonadejogo",
    ],
    afun: {
      baseURL: "https://afun.bet.br/sports",
      nameBetHome: "Afun",
    },
    xxbet: {
      baseURL: "https://www.xx.bet.br/sportView?bt-path=",
      nameBetHome: "XXbet",
    },
    onlybets: {
      baseURL: "https://onlybets.bet.br/sports",
      nameBetHome: "Onlybets",
    },
    apostaonline: {
      baseURL: "https://apostaonline.bet.br/sports",
      nameBetHome: "ApostaOnline",
    },
    zonadejogo: {
      baseURL: "https://www.zonadejogo.bet.br/sports",
      nameBetHome: "ZonadeJogo",
    },
    bingobet: {
      baseURL: "https://bingo.bet.br",
      nameBetHome: "Bingobet",
    },
    pinbet: {
      baseURL: "https://pin.bet.br",
      nameBetHome: "PinBet",
    },
    betboom: {
      baseURL: "https://betboom.bet.br/sport",
      nameBetHome: "BetBoom",
    },
    reals: {
      baseURL: "https://reals.bet.br/sports-betby?bt-path=",
      nameBetHome: "Reals",
    },
    jonbet: { baseURL: "https://jonbet.bet.br", nameBetHome: "Jonbet" },
  },
  betesporte: {
    allBetHomeClone: ["lancedesorte"],
    lancedesorte: {
      baseURL: "https://lancedesorte.bet.br",
      nameBetHome: "LancedeSorte",
    },
  },
};

export const listCloneBetHomeModeLive = {
  vbet: {
    segurobet: {
      baseURL: "https://www.seguro.bet.br/ao-vivo/match",
      nameBetHome: "Segurobet",
    },
    "1pra1": {
      baseURL: "https://www.1pra1.bet.br/ao-vivo/match/todayEvents",
      nameBetHome: "1pra1",
    },
    luckbet: {
      baseURL: "https://www.luck.bet.br/ao-vivo/match/todayEvents",
      nameBetHome: "LuckBet",
    },
    seubet: {
      baseURL: "https://www.seu.bet.br/ao-vivo/match",
      nameBetHome: "Seubet",
    },
    h2bet: {
      baseURL: "https://www.h2.bet.br/ao-vivo/match",
      nameBetHome: "H2Bet",
    },
    supremabet: {
      baseURL:
        "https://suprema.bet.br/pb/sports/live/event-view/Soccer/Brazil/1792/xxxxxxxxxxx-xxxxx-x/27656663/xxx-xxxxxx-xxxxxxx",
      e_sportBaseURL:
        "https://suprema.bet.br/pb/sports/live/event-view/xxe-sportxx/xxxx-xxxx/xxx-xxxxx/xxidzz",
      nameBetHome: "SupremaBet",
    },
    maximabet: {
      baseURL: "https://www.maxima.bet.br/ao-vivo/match",
      nameBetHome: "MaximaBet",
    },
    ultrabet: {
      baseURL: "https://ultra.bet.br/e/sport",
      nameBetHome: "UltraBet",
    },
  },
  stake: {
    allBetHomeClone: ["kto", "betwarrior"],
    kto: { baseURL: "https://www.kto.bet.br", nameBetHome: "Kto" },
    betwarrior: {
      baseURL: "https://apostas.betwarrior.bet.br/pt-br/sports/event/live",
      nameBetHome: "Betwarrior",
    },
    reidopitaco: {
      baseURL: "https://reidopitaco.bet.br/betting",
      nameBetHome: "ReidoPitaco",
    },
  },
};
//
export const listBetHomeDemarkOnFilter = createListBetHomeDemarkOnFilter(
  JSON.stringify(managerClonerBetHome),
);

export const listClones = listBetHomeDemarkOnFilter
  .flat()
  .filter(
    (item) => !managerClonerBetHome["allBetHomeAbleToClone"].includes(item),
  );

export const styleDataMarket = {
  common_data_market: {
    componentFunction: function (infoDataMarket, description) {
      return (
        <CommonCompenentDataMarket
          infoDataMarket={infoDataMarket}
          description={description}
        />
      );
    },
  },
  first_second_extra_time: {
    componentFunction: function (infoDataMarket, description) {
      return (
        <CompenentDataMarketFirstSecondExtraTime
          infoDataMarket={infoDataMarket}
          description={description}
        />
      );
    },
  },

  default_data_market: {
    componentFunction: function (infoDataMarket, description) {
      return (
        <CompenentDataMarketDefault
          infoDataMarket={infoDataMarket}
          description={description}
        />
      );
    },
  },

  dynamic_market: {
    componentFunction: function (infoDataMarket, description) {
      return (
        <CompenentDataMarketDynamic
          infoDataMarket={infoDataMarket}
          description={description}
        />
      );
    },
  },
};

export const timeSurebetAllowed = 900000;

//------📱📱📱📱📱📱📱📱📱📱📱📱📱📱📱📱📱📱CALCULATOR📱📱📱📱📱📱📱📱📱📱📱📱📱📱📱📱📱📱

export const partInfoOddSurebetJSON = '{"percent":0,"typeBet":"normal"}';

export const modelPopUpSettings = {
  popupWindowAll: {
    width: 800,
    height: 460,
    top: 0,
    left: 0,
  },
  popupWindowAll2: {
    width: 800,
    height: 460,
    top: 0,
    left: 0,
  },
};

export const bom_dia = "open__Pop_Up__Calculator";
export const listTypeUsers = ["user", "moderador", "admin"];
export const bonusAllowedRoles = ["admin", "moderador"];
